import { Box, Text } from '@factorialco/deprecated-design-system'

interface DetailLineProps {
  component: 'div' | 'li'
  title: string
  value: string
  style?: Partial<CSSStyleDeclaration>
}

const DetailLine = ({ component, title, value, style }: DetailLineProps) => {
  return (
    <Box component={component} style={style} flexDirection="row">
      <Box flexDirection="row" flexWrap="wrap" gap="s4">
        <Text.Normal size="200" color="grey800">
          {title}:
        </Text.Normal>

        <Text.Normal weight="medium" size="200" color="grey1000" overflowWrap>
          {value}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default DetailLine
